(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ci-media-carousel"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ci-media-carousel')) customElements.define('ci-media-carousel', class extends HTMLElement {
  connectedCallback() {
    this.abort?.abort();
    this.abort = new AbortController();
    const {signal} = this.abort;
    const track = this.querySelector('.ci-media-carousel__track');
    const slides = [...track.children];
    const nav = this.querySelector('.ci-media-carousel__nav');
    const status = this.querySelector('[data-carousel-status]');
    const buttons = [...nav.querySelectorAll('button')];
    nav.hidden = slides.length < 2;
    const index = () => Math.max(0, Math.min(slides.length - 1, Math.round(track.scrollLeft / Math.max(1, track.clientWidth))));
    const update = () => {
      const current = index();
      buttons[0].disabled = current === 0;
      buttons[1].disabled = current === slides.length - 1;
      status.textContent = status.dataset.label.replace('[current]', current + 1).replace('[total]', slides.length);
    };
    const move = step => track.scrollTo({left: Math.max(0, Math.min(slides.length - 1, index() + step)) * track.clientWidth, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
    buttons.forEach(button => button.addEventListener('click', () => move(Number(button.dataset.step)), {signal}));
    track.addEventListener('scroll', () => { clearTimeout(this.timer); this.timer = setTimeout(update, 120); }, {signal, passive: true});
    track.addEventListener('keydown', event => {
      if (event.target !== track || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
      event.preventDefault();
      move(event.key === 'Home' ? -slides.length : event.key === 'End' ? slides.length : event.key === 'ArrowRight' ? 1 : -1);
    }, {signal});
    document.addEventListener('shopify:block:select', event => {
      const slide = event.target.closest('.ci-media-carousel__slide');
      if (slide && slides.includes(slide)) track.scrollTo({left: slides.indexOf(slide) * track.clientWidth, behavior: 'instant'});
    }, {signal});
    this.resize = new ResizeObserver(update);
    this.resize.observe(track);
    update();
  }
  disconnectedCallback() { this.abort?.abort(); this.resize?.disconnect(); clearTimeout(this.timer); }
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["header-language-switch"] && !Shopify.designMode) return;
  try {
    if (['127.0.0.1', 'localhost', '[::1]'].includes(window.location.hostname)) {
    document.addEventListener('submit', (event) => {
      if (!event.target.matches('form.header-language-switch')) return;
      const button = event.submitter;
      const language = button?.value;
      if (!language || !button.dataset.previewRoot) return;

      const alternate = Array.from(document.querySelectorAll('link[rel="alternate"][hreflang]'))
        .find((link) => link.hreflang.toLowerCase() === language.toLowerCase());
      const translatedPage = new URL(alternate?.href || window.location.href, window.location.href);
      if (!['http:', 'https:'].includes(translatedPage.protocol)) return;

      const languages = Array.from(event.target.querySelectorAll('button[name="language_code"]'))
        .map((item) => item.value.toLowerCase());
      const segments = translatedPage.pathname.split('/');
      if (languages.includes(segments[1]?.toLowerCase())) segments.splice(1, 1);
      const pagePath = segments.join('/') || '/';
      const root = button.dataset.previewRoot.replace(/\/$/, '');
      const destination = new URL(window.location.href);
      destination.pathname = root + (pagePath === '/' ? '' : pagePath) || '/';
      for (const [key, value] of translatedPage.searchParams) {
        destination.searchParams.set(key, value);
      }
      event.preventDefault();
      window.location.assign(destination.href);
    });
  }
  } catch(e) { console.error(e); }
})();

})();
